<script>
  import ListMain from '../../../../../app/components/list/Main.vue'
  import ListHeader from '../../../../../app/components/list/Header.vue'
  import ListEditButton from '../../../../../app/components/list/EditButton.vue'
  import ListDeleteButton from '../../../../../app/components/list/DeleteButton.vue'
  import RegistrationStatusLabel from './labels/RegistrationStatusLabel'
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import DataService from '../../../../services/dataService'
  import dateMixin from '../../../../../mixins/helper'
  import bus from '@utils/bus'
  import {isEmpty} from 'lodash'
  import {mapGetters} from 'vuex'

  let defaultSearchData = {
    event_main_id: null
  }

  export default {
    components: {ListMain, ListHeader, ListEditButton, ListDeleteButton, RegistrationStatusLabel},
    mixins: [dateMixin],
    data () {
      return {
        isLoadingData: true,
        filters: {ref_pessoa: '', status_id: '', dates: [], modality_id: '', filter_by_current_event: true, show_modalities: false},
        dependencies: {}
      }
    },
    mounted () {
      this.getDependencies()
      const eventMainId = this.$route.params.eventMainId || null
      const id = this.$route.params.id || null
      defaultSearchData.event_main_id = eventMainId
      let searchData = Object.assign({'modalities.event_modality': {has: [{event_id: id}]}}, defaultSearchData)
      bus.$emit('list-init', {
        domain: 'registration',
        relations: ['status', 'person', 'papers', 'modalities.event_modality.event', 'modalities.activities'],
        data: searchData
      }, () => {
        this.isLoadingData = false
      })
    },
    computed: {
      ...mapGetters(['listStore']),
      totalAmount: function () {
        return this.currencyEnToBr(this.listStore.listData.filter(item => item.status.key !== 'pago' && item.status.key !== 'cancelado').reduce((total, nextItem) => total + (nextItem.invoice ? parseFloat(nextItem.invoice.amount) : 0), 0))
      },
      totalAmountPaid: function () {
        return this.currencyEnToBr(this.listStore.listData.filter(item => item.status.key === 'pago').reduce((total, nextItem) => total + (nextItem.invoice ? parseFloat(nextItem.invoice.amount) : 0), 0))
      }
    },
    methods: {
      getDependencies () {
        DataService.get([{domain: 'status'}, {domain: 'modality'}]).then((result) => {
          this.dependencies = result
        })
      },
      onFilter () {
        const id = this.$route.params.id || null
        const mainEventId = this.$route.params.mainEventId || null
        let searchData = Object.assign({}, defaultSearchData)
        if (this.filters.filter_by_current_event) {
          searchData['modalities.event_modality'] = {has: [{event_id: id}]}
        } else {
          searchData.event_main_id = mainEventId
        }
        if (this.filters.status_id) {
          searchData.status_id = this.filters.status_id
        }
        if (!isEmpty(this.filters.ref_pessoa)) {
          searchData.person = {has: [{ref_pessoa: {ilike: '%' + this.filters.ref_pessoa + '%'}}]}
        }
        if (this.filters.modality_id) {
          if (searchData['modalities.event_modality']) {
            searchData['modalities.event_modality'].has.push({modality_id: this.filters.modality_id})
          } else {
            searchData['modalities.event_modality'] = {has: [{modality_id: this.filters.modality_id}]}
          }
        }
        if (this.filters.dates) {
          let startDate = this.dateFormat(this.filters.dates[0], 'en')
          let endDate = this.dateFormat(this.filters.dates[1], 'en')
          if (startDate.length > 0 && endDate.length > 0) {
            searchData.created_at = {
              between: [startDate + ' 00:00:00', endDate + ' 23:59:59']
            }
          } else if (startDate.length > 0 && endDate.length === 0) {
            searchData.created_at = {
              between: [startDate, startDate]
            }
          } else if (startDate.length === 0 && endDate.length > 0) {
            searchData.created_at = {
              between: [endDate, endDate]
            }
          }
        } else {
          this.filters.dates = []
        }
        bus.$emit('list-filter', this.filters, searchData)
      },
      onFilterClean () {
        const id = this.$route.params.id || null
        const searchData = Object.assign({'modalities.event_modality': {has: [{event_id: id}]}}, defaultSearchData)
        this.filters = {
          ref_pessoa: '',
          status_id: '',
          dates: [],
          modality_id: '',
          filter_by_current_event: true
        }
        bus.$emit('list-filter-clean', this.filters, searchData)
      },
      onDestroy (item) {
        bus.$emit('list-destroy-item', item)
      },
      cancelRegistration (registration) {
        this.isSubmitted = true
        this.$swal({
          title: 'Deseja realmente cancelar sua inscrição?',
          text: 'Essa ação não pode ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            restfulService.put('registration', 'cancel', registration.id)
              .then(response => {
                this.isSubmitted = false
                notifyService.success({hideLoader: true, message: 'A inscrição foi cancelada com sucesso.'})
                this.onFilter()
                bus.$emit('hide-loader')
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      addActivity (registrationId, eventModalityRegistrationId) {
        const data = {
          registration_id: registrationId,
          event_modality_registration_id: eventModalityRegistrationId
        }

        this.isSubmitted = true
        this.$swal({
          title: 'Deseja realmente inserir a presença?',
          text: 'Essa ação não pode ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            restfulService.post('registration', 'activities/add', null, data)
              .then(response => {
                this.isSubmitted = false
                notifyService.success({hideLoader: true, message: 'A presença foi registrada com sucesso.'})
                this.onFilter()
                bus.$emit('hide-loader')
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      }
    },
    beforeMount () {
      this.listStore.listData = []
    }
  }
</script>

<template>
    <div>
        <div class="header">
            <h2>Lista de Inscrições</h2>
        </div>
        <ListMain>
            <div slot="filters">
                <el-card class="el-card__search_list box-card">
                    <div slot="header">
                        <span>Filtrar Listagem</span>
                        <div>
                            <el-button type="primary" @click="onFilter">Pesquisar</el-button>
                            <el-button type="default" @click="onFilterClean">Limpar</el-button>
                        </div>
                    </div>
                    <el-form :inline="true" :model="filters" class="demo-form-inline">
                        <el-form-item label="Matrícula">
                            <el-input v-model="filters.ref_pessoa" placeholder="Filtrar por matrícula"/>
                        </el-form-item>
                        <el-form-item label="Data da Inscrição">
                            <el-date-picker
                                    v-model="filters.dates"
                                    type="daterange"
                                    format="dd/MM/yyyy"
                                    placeholder="Filtrar por data">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Status">
                            <el-select v-model="filters.status_id"
                                       filterable
                                       placeholder="Filtrar Status"
                                       empty-text="Nenhum registro encontrado">
                                <el-option v-for="item in dependencies.status"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Modalidade">
                            <el-select v-model="filters.modality_id"
                                       filterable
                                       placeholder="Filtrar Modalidade"
                                       empty-text="Nenhum registro encontrado">
                                <el-option v-for="item in dependencies.modalities"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Filtrar pelo evento atual">
                            <el-switch
                                    v-model="filters.filter_by_current_event"
                                    active-text="Sim"
                                    inactive-text="Não">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="Mostrar modalidades">
                            <el-switch
                                    v-model="filters.show_modalities"
                                    active-text="Sim"
                                    inactive-text="Não">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>

            <div slot="list" v-if="!isLoadingData">
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Código</th>
                        <th>Pessoa</th>
                        <th>E-mail</th>
                        <th>Instituição</th>
                        <th>Data</th>
                        <th>Status</th>
                        <th width="60">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listStore.listData">
                        <td>{{item.id}}</td>
                        <td>
                          {{item.person.pessoa ? item.person.pessoa.nome : 'Cadastro não encontrado no Segue'}} ({{item.person.ref_pessoa}})

                          <div style="margin-top: 8px" v-if="filters.show_modalities">
                            <table class="custom-table-list">
                              <tr>
                                <th>Modalidades</th>
                                <th>Ações</th>
                              </tr>
                              <tr v-for="modality in item.modalities">
                                <td>{{ modality.event_modality.event.title }}</td>
                                <td><el-button type="primary"
                                               plain
                                               size="mini"
                                               @click="addActivity(item.id, modality.id)"
                                               v-if="!modality.activities.length">Inserir presença</el-button></td>
                              </tr>
                            </table>
                          </div>
                        </td>
                        <td>{{item.person.pessoa ? item.person.pessoa.email : ''}}</td>
                        <td>{{item.institution.name}}</td>
                        <td>{{item.created_at | dateTimeEnToBr}}</td>
                        <td>
                            <div>
                                <registration-status-label :status-id="item.status_id"
                                                           :status-name="item.status.name"/>
                            </div>
                            <div class="small">Última Atualização: {{item.status_updated_at | dateTimeEnToBr }}</div>
                        </td>
                        <td>
                            <el-button type="danger"
                                       size="mini"
                                       @click="cancelRegistration(item)"
                                       :disabled="item.papers.length > 0 || item.status.key === 'cancelado'"
                                       title="Cancelar Inscrição">
                                <i class="fa fa-times"></i>
                            </el-button>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th colspan="5" align="right">Total:</th>
                        <th>R$ {{totalAmount}}</th>
                        <th></th>
                    </tr>
                    <tr>
                        <th colspan="5" align="right">Total Recebido:</th>
                        <th>R$ {{totalAmountPaid}}</th>
                        <th></th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </ListMain>
    </div>
</template>

<style lang="scss">
    .small {
        font-weight: 400;
        font-size: 11px;
        color: #555555;
    }
</style>




// WEBPACK FOOTER //
// Registrations.vue?cac038c0